import {
  renderMainLeftCell,
  renderMainRightCell,
  renderSectionHeaderAsOfDate,
  renderRowGaps
} from '../helpers';
import { percentSingleDecimal } from '../download-data-styles';

export const renderQualitySummaryRow = rating => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(rating.label);
  rowString += renderMainRightCell(`${rating.DataValue}%`, percentSingleDecimal);
  rowString += `</tr>`;
  return rowString;
};

export const qualitySummaryModule = (title, asOfDateString, data) => {
  let moduleString = ``;
  moduleString += renderSectionHeaderAsOfDate(title, asOfDateString);
  moduleString += renderRowGaps();
  data.forEach(rating => {
    moduleString += renderQualitySummaryRow(rating);
  });
  moduleString += renderRowGaps(2);
  return moduleString;
};
